/* @flow */

import * as types from 'src/shared/domain/braindate/action/braindateActionTypes';
import {
  createReducer,
  setRequestResult,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';

const initialState = {
  result: [],
  isFetching: false,
};

const _createBraindate = (state: Object, action: Object) => {
  const { result } = state;
  const { braindateId } = action;

  return {
    ...state,
    result: [...result, braindateId],
  };
};

const _deleteBraindate = (state: Object, action: Object) => {
  const { id } = action;
  const { result } = state;
  const index = result.indexOf(id);

  if (index === -1) {
    return state;
  }
  return {
    ...state,
    result: [...result.slice(0, index), ...result.slice(index + 1)],
  };
};

export default createReducer(initialState, {
  [types.SIMULATE_BRAINDATES_FETCH]: setFetchingState,
  [types.FETCH_BRAINDATES_REQUEST]: setFetchingState,
  [types.FETCH_BRAINDATES_SUCCESS]: setRequestResult,
  [types.FETCH_BRAINDATES_FAILURE]: unsetFetchingState,
  [types.CREATE_BRAINDATE]: _createBraindate,
  [types.DELETE_BRAINDATE_LOCALLY]: _deleteBraindate,
});
